export function namePropertyIsString(prop) {
    return typeof prop === "string";
}
export var namePropertyValue = function (prop) {
    return typeof prop === "string" ? prop : prop.value;
};
